import { Link, useLocation } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_group-ice-sessions/artifacts/hnppn2we_Sligo%20On%20Ice%20Logo%20-%20Small%20Image.png";
const PUBLIC_BOOKING_URL = "https://ice-rink-bookings.emergent.host/schools/sligo";

export const Header = () => {
  const loc = useLocation();
  const linkCls = (active) =>
    `font-mono-tight text-xs uppercase tracking-[0.2em] px-3 py-2 border-2 border-slate-900 brutal-hover brutal-shadow ${
      active ? "bg-slate-900 text-white" : "bg-white text-slate-900"
    }`;

  return (
    <header
      className="border-b-2 border-slate-900 bg-white sticky top-0 z-40"
      data-testid="app-header"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-4 md:px-8 py-4">
        <a
          href={PUBLIC_BOOKING_URL}
          className="flex items-center gap-3"
          data-testid="home-link"
        >
          <div className="w-12 h-12 bg-slate-900 border-2 border-slate-900 flex items-center justify-center brutal-shadow overflow-hidden">
            <img src={LOGO_URL} alt="Sligo On Ice" className="w-full h-full object-cover" />
          </div>
          <div>
            <div className="font-display text-lg leading-none uppercase">
              Sligo On Ice 2026
            </div>
            <div className="font-mono-tight text-[10px] uppercase tracking-[0.25em] text-slate-500 mt-1">
              Rink Booking · 2026/27
            </div>
          </div>
        </a>

        <nav className="flex items-center gap-3">
          <a href={PUBLIC_BOOKING_URL} className={linkCls(false)} data-testid="nav-book">
            Book
          </a>
          <Link to="/lookup" className={linkCls(loc.pathname === "/lookup")} data-testid="nav-lookup">
            Lookup
          </Link>
          <Link to="/admin" className={linkCls(loc.pathname.startsWith("/admin"))} data-testid="nav-admin">
            Admin
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
